<div class="uploaded-list">
  @for (document of documentsForSign; track $index) {
    <app-file-label
      [hideDeleteBtn]="true"
      (downloadFile)="downloadFile(document.documentId, document.name)"
    >
      {{ document.name }}
    </app-file-label>
  }
</div>